import { ComponentProps, memo } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { IBlogCategoryTagProps } from './BlogCategoryTag.types';
import styles from './styles.module.scss';

export const BlogCategoryTag = memo<IBlogCategoryTagProps>(
  ({ label, className, active, isLink, ...rest }) => {
    if (isLink) {
      const props = rest as ComponentProps<typeof Link>;
      return (
        <Link
          className={classNames(styles.container, className, {
            [styles.modInactive]: active === false,
            [styles.modActive]: active,
          })}
          {...props}
        >
          {label}
        </Link>
      );
    }

    const props = rest as ComponentProps<'button'>;

    return (
      <button
        type="button"
        className={classNames(styles.container, className, {
          [styles.modInactive]: active === false,
          [styles.modActive]: active,
        })}
        {...props}
      >
        {label}
      </button>
    );
  },
);

BlogCategoryTag.displayName = 'BlogCategoryTag';

export default BlogCategoryTag;
